<template>
  <v-flex xs12 md8 xl6>
    <copy-to
      :window-visible="windowVisible"
      :categoryId="categoryId"
      @close="closeModal"
      @save="closeAndRefresh"
    ></copy-to>
    <page-toolbar>
      <kendo-dropdownlist
        v-model="categoryId"
        :data-source="categoryDataSource"
        :data-text-field="'flowCategoryName'"
        :data-value-field="'flowCategoryId'"
      ></kendo-dropdownlist>
      <kendo-button
        icon="copy"
        title="Copy from"
        @click="toggleModal"
        v-if="!isReadOnly"
      ></kendo-button>
    </page-toolbar>
    <div ref="flowTypeGrid"></div>
  </v-flex>
</template>
<script>
import $ from '@/helpers/jquery-bridge'
import {enableExportExcel} from '@/helpers/export-helper'
import {jsonDropDownEditor, createCheckboxColumn} from '@/helpers/kendo-editors'
import CopyTo from './CopyTo'
import axios from 'axios'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import security from '@/mixins/security'

export default {
  name: 'FlowType',
  mixins: [security],
  components: {
    CopyTo,
    PageToolbar,
  },
  mounted() {
    let vm = this
    const grid = $(this.$refs.flowTypeGrid)
      .kendoGrid({
        autoBind: false,
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 15,
          transport: {
            read: {
              type: 'GET',
              url: '/api/config/flowType',
              data: () => ({
                clientId: this.clientId,
                flowCategoryId: this.categoryId,
              }),
              dataType: 'json',
            },
            update: {
              type: 'PUT',
              url: '/api/config/flowType',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'flowTypeId',
              fields: {
                flowTypeId: {type: 'number', editable: false, defaultValue: 0},
                name: {type: 'string', validation: {required: true}},
                description: {type: 'string', validation: {required: true}},
                signId: {type: 'number', defaultValue: 1},
                sign: {type: 'string', validation: {required: true}},
                flowCategory: {type: 'string', editable: false},
                typeNumId: {type: 'number', editable: false},
                typeNum: {type: 'string', editable: false},
                sequence: {type: 'number', defaultValue: -1},
                isShown: {type: 'boolean', defaultValue: true},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        editable: !vm.isReadOnly && 'inline',
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {
            command: [{name: 'edit'}],
            width: 40,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {
            title: 'Name',
            field: 'name',
            width: 100,
            attributes: {style: 'text-align: left;'},
            editor:
              '<input name="name" required="required" type="text" class="k-input k-textbox" data-bind="value:name" />',
          },
          {
            title: 'Description',
            field: 'description',
            width: 200,
            attributes: {style: 'text-align: left;'},
            editor:
              '<input name="description" required="required" type="text" class="k-input k-textbox" data-bind="value:description" />',
          },
          {
            title: 'Sign',
            field: 'sign',
            width: 100,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: center;'},
            editor: jsonDropDownEditor(
              'signId',
              'sign',
              '/api/config/flowType/getSigns',
              {},
              false,
            ),
          },
          createCheckboxColumn(
            $(this.$refs.flowTypeGrid),
            'isShown',
            {title: 'Is Shown', width: 82},
            this.isReadOnly,
          ),
        ],
      })
      .addClass('k-dragged-grid')
      .getKendoGrid()

    enableExportExcel(grid, '/api/config/flowType/exportToExcel', $('.page_toolbar-item'))

    if (!this.isReadOnly) {
      grid.table.kendoSortable({
        filter: 'tr:not(tr[data-role=editable])',
        hint: element => {
          var table = $('<table class="k-grid k-dragged-table"></table>')
          table.append(element.clone())
          table.css('opacity', 0.82)
          return table
        },
        cursor: 'ns-resize',
        placeholder: () => $('<tr class="k-dragged-placeholder"></tr>'),
        change: async e => {
          const flowTypeGrid = grid,
            skip = flowTypeGrid.dataSource.skip(),
            newIndex = e.newIndex + skip,
            selectedDataItem = flowTypeGrid.dataSource.getByUid(e.item.data('uid'))

          flowTypeGrid.dataSource.remove(selectedDataItem)
          flowTypeGrid.dataSource.insert(newIndex, selectedDataItem)

          await axios.post('/api/config/flowType/updateSequence', {
            clientId: this.clientId,
            newIndex: e.newIndex,
            selectedFlowTypeId: selectedDataItem.flowTypeId,
            categoryId: selectedDataItem.flowCategoryId,
          })

          await flowTypeGrid.dataSource.read()
        },
      })
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  watch: {
    categoryId(value) {
      if (value == null) return

      let grid = $(this.$refs.flowTypeGrid).getKendoGrid()
      grid.dataSource.read()
    },
  },
  data() {
    return {
      categoryDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/config/flowType/getFlowCategories',
            contentType: 'application/json',
            type: 'GET',
          },
        },
        requestEnd: ({response}) => {
          if (response) {
            const [first] = response
            this.categoryId = first.flowCategoryId
          }
        },
      }),
      categoryId: null,
      windowVisible: false,
    }
  },
  methods: {
    toggleModal() {
      this.windowVisible = !this.windowVisible
    },
    openModal() {
      this.windowVisible = true
    },
    closeModal() {
      this.windowVisible = false
    },
    closeAndRefresh() {
      const grid = $(this.$refs.flowTypeGrid).getKendoGrid()
      grid.dataSource.read()
      this.closeModal()
    },
  },
  beforeDestroy() {
    const grid = $(this.$refs.flowTypeGrid).getKendoGrid()
    if (grid) {
      grid.destroy()
    }
  },
}
</script>

<style>
.k-dragged-table {
  background-color: #f8f8f8;
}
.k-dragged-grid {
  height: calc(100vh - 90px - 82px - 32px);
}
.k-dragged-grid tbody tr {
  cursor: move;
}
.k-dragged-placeholder {
  outline-style: dashed !important;
  outline-width: 1px !important;
  outline-color: #ff6358 !important;
}
</style>
